import { render } from "./BankDetailsValue.vue?vue&type=template&id=f444cefe"
import script from "./BankDetailsValue.vue?vue&type=script&lang=js"
export * from "./BankDetailsValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__